import { render, staticRenderFns } from "./uploadModal.vue?vue&type=template&id=dce54544&scoped=true"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"
import style0 from "./uploadModal.vue?vue&type=style&index=0&id=dce54544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce54544",
  null
  
)

export default component.exports